import dayjs from "dayjs";

import { Models } from "api/types";
import { formatToSimpleDate } from "utils/dayjsUtils";

export interface RetailProductOrderHeaderProps {
  order: Models<"DisplayRetailProductOrderFromPerson">;
  retailProductRefunds: Models<"DisplayRetailProductRefundSupportDetailsForOrder">;
}

export const RetailProductOrderHeader = ({
  order,
  retailProductRefunds,
}: RetailProductOrderHeaderProps) => {
  const refundItemLastInitiatedAtUtc =
    retailProductRefunds.items[retailProductRefunds.items.length - 1]
      ?.initiatedAtUtc;

  return (
    <div className="px-4">
      <div className="flex flex-col rounded-lg bg-white p-4 shadow-subtle">
        <div className="flex items-center justify-between">
          <p className="text-bold3">Order #{order.orderNumber.toString()}</p>
        </div>
        {retailProductRefunds.items.length > 0 && (
          <p className="text-body3">
            Refund requested {formatToSimpleDate(refundItemLastInitiatedAtUtc)}
          </p>
        )}
        <p className="text-body3">
          Placed on {formatToSimpleDate(order.createdOnUtc)}
        </p>
      </div>
    </div>
  );
};
